import { COMPANY } from '../../config/brand'

/**
 * Copyright + licence line for public footers. Code-owned (not CMS-managed)
 * so the company name, licence number and address always match the licence.
 */
export default function CompanyLegalLine({ lang = 'en', className = '' }) {
  const isAr = lang === 'ar'
  const year = new Date().getFullYear()
  return (
    <div className={`space-y-1 text-gray-500 ${className}`}>
      <div>
        {isAr
          ? `© ${year} ${COMPANY.legalNameAr}. جميع الحقوق محفوظة.`
          : `© ${year} ${COMPANY.legalName}. All rights reserved.`}
      </div>
      <div className="text-xs">
        {isAr
          ? `رخصة رقم ${COMPANY.licenceNo} · ${COMPANY.addressAr}`
          : `Licence no. ${COMPANY.licenceNo} · ${COMPANY.address}`}
      </div>
    </div>
  )
}
